import * as React from "react";
import { forwardRef } from "react";
const SvgIconInfo = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 8, height: 8, viewBox: "0 0 8 8", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M25.23 3.5a.922.922 0 1 0 .922.922.92.92 0 0 0-.922-.922M24 6.267V7.5h.615v1.9H24v1.23h2.459V9.4h-.615V6.267z", "data-name": "icon/info", transform: "translate(-21.111 -3.19)", fill: "#727d8e" }));
const ForwardRef = forwardRef(SvgIconInfo);
export { ForwardRef as ReactComponent };
